<template>
    <div>
      <div style="display: flex;">
        <div class="logo-container">
          <img
            class="logo"
            width="40"
            height="40"
            src="../../assets/img/logo.png"
            alt="logo"
          />
        </div>
        <div style="display:flex;width:100%;">
          <div style="font-size: 30px;width:85%">合益.电商.商家系统</div>
          <div style="width: 15%;height: 50px;position: relative;">
          <el-col class="col-right" :span="12">
            <el-dropdown size="small">
              <span class="el-dropdown-link">
                {{user_name}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu>
                <el-dropdown-item @click.native="handleClick('0')">个人中心</el-dropdown-item>   
                <el-dropdown-item @click.native="handleClick('1')">退出系统</el-dropdown-item>             
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
          <img style="width: 40px;height:40px;border-radius: 100%; overflow: hidden;" :src="touxiang_url" />
        </div>
        </div>
        
      </div>
      <!-- 导航 -->
      <div style="display: flex;width:100%;">
        <div style="width: 15%;margin-top: 20px;">
          <LeftNav style="width: 100%;"></LeftNav>
        </div>
        <div style="width:80%;margin-top:0px;">
          <el-main style="width:100%">
            <transition name="houtai_name" mode="out-in">
              <router-view />
              <slot/>
            </transition>
          </el-main>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import eventBus from "@/api/eventBus.js"
  import LeftNav from "../layout/leftnav.vue";
  import global from "@/global/global.js"

  export default {
    //注册组件
    components: {
        eventBus,
        LeftNav,
    },
    data() {
      return {
        touxiang_url:'',
        user_name:'',
      };
    },
    created () {
      setTimeout(()=>{this.$router.replace("/shouye");},1000);
      // 
      this.touxiang_url = "https://www.zizai-yun.com.cn/touxiang/"+global.openid+".jpeg";
      this.user_name = "欢迎你."+global.name;
    },

    mounted() {
      // this.$router.replace("/shouye");
      eventBus.$emit("ENTER_HOUTAI",0);
      eventBus.$on('ENTER_HOUTAI_RIGHT', (data)=> {
        this.$router.replace(data);
      });

    },
    methods: {
      handleClick(data){
          if (data == '0') {
          } else if (data == '1') {
            global.qiye_id = "0";
            global.qiye_name = "0";
            global.qiye_addr = "0";
            global.qiye_shenfen = "0";
            global.openid = "0";
            global.phone = "0";
            global.name = "0";
            global.denglu_stat = 0;
            eventBus.$emit("ENTER_HOUTAI",1);
            this.$router.replace('/bwIndex');
          }
      },
      handleSelect(key, keyPath) {
          console.log(key, keyPath);
      },
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  